window.addEventListener("load", function () {
  // Nội dung Frame2 là list event tĩnh — không cần xử lý JS
});
